/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedAccountTypeDropdown200,
  GetApiV1PersonSharedAccountTypeDropdown401,
  GetApiV1PersonSharedAccountTypeDropdown500,
  GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedAccountTypeDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedAccountTypeDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedAccountTypeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedAccountTypeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAccountTypeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedAccountTypeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAccountTypeDropdown500>;

export const getApiV1PersonSharedAccountTypeDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedAccountTypeDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedAccountTypeDropdownQueryResponse>;
